
export default {
  share: {
    'fullUrl': 'Completa',
    'shortUrl': 'acortar',
    'urlCopied': 'URL copiada en el portapapeles.',
    'clickToCopy': 'Haga clic para copiar la URL',
    'share': 'Compartir (haga clic para copiar)',
    'shareLink': 'Compartir enlace',
    'short': 'Acortar URL',
    'copyUrlInfo': 'También puede copiar el enlace desde la barra de direcciones de su navegador.',
    'urlShortened': 'URL acortada',
    'shorteningNotPossible': 'No se puede generar una URL corta. Por favor, utilice la URL completa.',
    'embedCodeCopied': 'Código para incrustar el mapa copiado',
    'embed': 'Código para incrustar (haga clic para copiar)',
    'embedInstructions': 'Utilice este código para incrustar el mapa de ORS en un sitio web'
  }
}
